// extracted by mini-css-extract-plugin
export var numpadContainer = "_q2-1";
export var phoneButton = "_q2-0";